import { useQuery } from "./useApi";
import { featuresService, type FeatureQueryParams } from "../api/features.service";

/**
 * Hook to fetch features with optional filtering
 */
export function useFeatures(params?: FeatureQueryParams) {
  return useQuery(
    () => featuresService.get(params),
    [params?.type, params?.scope, params?.status, params?.pageType, params?.site, params?.language],
  );
}

/**
 * Hook to fetch a single feature by code
 */
export function useFeature(code: string) {
  return useQuery(() => featuresService.getByCode(code), [code]);
}
